import { Box, Chip, SxProps, Theme } from "@mui/material";
import { filter } from "lodash";

import { GqlFilterOption } from "~/__generated__";

type Props = {
    filterOptions: GqlFilterOption[];
    values?: Record<string, string>;
    onChange: (key: string, value: string) => void;
    sx?: SxProps<Theme>;
};

export default function GaiaActiveFilters({ filterOptions, values, onChange, sx = undefined }: Props) {
    const activeFilters = filter(filterOptions, option => (values ? !!values[option.key] : false));

    return (
        <Box
            component="ul"
            sx={{
                display: "flex",
                flexDirection: "row",
                gap: 1,
                justifyContent: "start",
                flexWrap: "wrap",
                listStyle: "none",
                p: 1,
                m: 0,
                ...sx,
            }}
        >
            {values &&
                activeFilters.map(option => (
                    <li key={option.key}>
                        <Chip
                            sx={{
                                maxWidth: 240,
                            }}
                            label={`${option.label}: ${values[option.key]}`}
                            onDelete={() => {
                                onChange(option.key, "");
                            }}
                        />
                    </li>
                ))}
        </Box>
    );
}
